<template>
  <div>
    <div
      v-for="(section, index) in sections"
      :key="index"
      :value="section"
      class="survey-block"
    >
      <h3>{{ section.title }}</h3>
      <table
        v-for="(part, partIndex) in section.parts"
        :key="partIndex"
        :value="part"
        class="table table-striped table-hover"
      >
        <thead>
          <tr>
            <th>{{ part.title }}</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
          </tr>
        </thead>
        <tbody>
          <SurveyQuestion
            v-for="(question, qIndex) in part.questions"
            :key="qIndex"
            :value="question.value"
            :question="question"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SurveyQuestion from './SurveyQuestion';

export default {
  name: "SurveySection",
  components: { SurveyQuestion},
  props: { sections: { type: Array, required: true}},
};
</script>
